"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
var react_1 = __importDefault(require("react"));
var typography_1 = require("../../../typography");
var styles_1 = require("./styles");
var Field = function (_a) {
    var id = _a.id, label = _a.label, hint = _a.hint, required = _a.required, error = _a.error, children = _a.children;
    return (react_1.default.createElement(styles_1.Wrapper, { "data-component-name": "Field" },
        label && (react_1.default.createElement(styles_1.Label, { htmlFor: id },
            react_1.default.createElement(typography_1.Body, { level: "3", color: !!error ? 'RED_50' : 'GREY_90', inline: true },
                label,
                " ",
                required && react_1.default.createElement("span", { className: "required" }, "*")))),
        children,
        !error && hint ? react_1.default.createElement(styles_1.Hint, null, hint) : null,
        error ? react_1.default.createElement(styles_1.Error, null, error) : null));
};
exports.Field = Field;
exports.default = exports.Field;
